import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Card, Checkbox, message, Button } from 'antd';
import PageHeader from '@components/common/PageHeader';
import { create as createApp } from '@store/admin/apps/actions';
import { singleAppPrefix } from '@src/routers/utils';
import { checkIsInternalUser } from '@src/globalStore/profileStore';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 4,
    },
  },
};

const ApplicationCreate = ({ create }) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const isInternalUser = checkIsInternalUser();

  const onCreated = (err, app) => {
    setSubmitting(false);
    if (err) {
      message.error('Cannot create a new applicaiton');
      return;
    }
    message.success('New application created');
    navigate(`${singleAppPrefix}/manage/apps/detail/${app.clientId}`);
  };

  const handleSubmit = (values) => {
    const { title, description = '', isInternal = false } = values;
    setSubmitting(true);
    create({ title, description, inactive: false, isInternal }, onCreated);
  };

  return (
    <div>
      <PageHeader
        style={{ marginTop: '5px', marginLeft: '1px', backgroundColor: 'white' }}
        title="Create New Application"
        backIcon={<Link to={`${singleAppPrefix}/manage/apps/list`}>Applications</Link>}
      />
      <Card title="General Settings">
        <Form {...formItemLayout} onFinish={handleSubmit}>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Title is required.' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea />
          </Form.Item>
          {isInternalUser && (
            <Form.Item
              label="For Internal Use"
              name="isInternal"
              valuePropName="checked"
              initialValue={false}
            >
              <Checkbox />
            </Form.Item>
          )}
          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit" disabled={isSubmitting}>
              Create
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default connect(null, { create: createApp })(ApplicationCreate);
